import script from "./rightCard2.vue?vue&type=script&setup=true&lang=js"
export * from "./rightCard2.vue?vue&type=script&setup=true&lang=js"

import "./rightCard2.vue?vue&type=style&index=0&id=e146f4b4&scoped=true&lang=scss"

import exportComponent from "E:\\maoqiaoProjectFile\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e146f4b4"]])

export default __exports__